// gatsby-browser.js
// Smooth page fade on first load and between route changes.

const enter = () => {
  // Start the new page "hidden", then fade to default styles
  document.body.classList.add("page-enter")
  // double RAF so the class removal happens in a new frame
  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      document.body.classList.remove("page-enter")
    })
  })
}

export const onInitialClientRender = () => {
  enter()
}

export const onPreRouteUpdate = () => {
  // Fade OUT the current page before navigation
  document.body.classList.add("page-leave")
  document.body.classList.remove("page-enter")
}

export const onRouteUpdate = () => {
  // Remove leave (old page), then fade IN the new one
  document.body.classList.remove("page-leave")
  enter()
}
